import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  StepContent,
} from '@mui/material';
import { PEOPLE } from '@pages/SavingsCalculator/constants';
import { FormStepProps, ValueByStep } from '@pages/SavingsCalculator/types';
import { useTranslation } from 'react-i18next';

const PeopleStep = ({ values, setStepValue }: FormStepProps) => {
  const { t } = useTranslation();
  const handleVolumeChange = (e: SelectChangeEvent<string>) => {
    setStepValue({
      newStep: ValueByStep.people + 1,
      value: e.target.value,
    });
  };
  return (
    <StepContent>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <Select
          displayEmpty
          value={values.step3}
          disabled={!values.step2}
          onChange={handleVolumeChange}
        >
          <MenuItem disabled value="">
            <em>{t('svngsSelect')}</em>
          </MenuItem>
          {PEOPLE.map((people) => (
            <MenuItem key={people.key} value={people.key}>
              {people.value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </StepContent>
  );
};

export default PeopleStep;
